// removed by extract-text-webpack-plugin
module.exports = {"Row":"hT-QPFpJAndInc6dOqgdw","Buttons":"_3tyzxDhzCr6Q7JAI81WeOO","Table":"_1g8rj6xq8gDZT2SK45jTdX","DoctorHover":"_3rNM4GoxWvHTI4Kp83lz82","DoctorTooltip":"_3Nk5wQqZ3mNd5-DRDUc13W","ClientHover":"fwQ6xA_NET0XCFYZXhEv1","ClientTooltip":"_1yAolGPNMVFEYhzI5iBuTy","Clickable":"IeBMbGkWRUta_80nHywoK","Order":"_3LIsFtUxEmaULE_e0LYWez","QRCode":"_1TMXD3CEvwzkbbgrXYyrqx","Confirm":"_11YyHv3UdWTlncl5irrJvJ","Img":"_1Bh4pjLYZLxsG_Hs_b4K10","Flex":"_3TVNpBWtfOSRWZjwOvn7HV","Background":"_1ji6RwAoo7_2jUprrCmAIb","Cat":"_2uk_nMMFAwyhr5Ruk6fqDa","SmallRow":"_1JA7oW0y-MIjwgAgOYpp2y"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Admin/Admin.css
// module id = 362
// module chunks = 0